<template>
    <span class="paragraph-first-letter-big" :class="[ options.color || '']" v-html="options.letter"></span>
</template>

<script>
export default {
    name: "ParagraphFirstLetterBig",
    props: {
        options: null
    }
}
</script>

<style scoped lang="scss">
.paragraph-first-letter-big{
    @apply text-9xl font-bold leading-none float-left;
    @apply mr-3 -ml-2.5;

    font-size: 10.5rem;
    margin-top: 0px;
    line-height: 0.8;
}
</style>
